import { useEffect, useState } from 'react'

let isDialogOpenState = false
let listeners = []

const setVerifyPaymentDialogState = (state) => {
    isDialogOpenState = state
    listeners.forEach(listener => listener(isDialogOpenState))
}

const subscribe = (listener) => {
    listeners.push(listener)
    return () => {
        listeners = listeners.filter(l => l !== listener)
    }
}


export const useVerifyPayment = () => {
    const [isOpen, setIsOpen] = useState(isDialogOpenState)

    useEffect(() => {
        const unsubscribe = subscribe(setIsOpen)
        return () => unsubscribe()
    }, []);

    return isOpen
}

export const toggleVerifyPayment = (state) => setVerifyPaymentDialogState(state)